import { makeStyles } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';

const useStyles = makeStyles(theme => ({
}));
const ListRecipientsScreen = ({}) => {
  const classes = useStyles()
  return (
    <>src/pages/CustomerBookingCreate/7/2/ListRecipients/index.jsx</>
  )
}

export {ListRecipientsScreen}